module.exports = __webpack_public_path__ + "img/img-qcode.8cdaa2ec.png";